// store/index.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    isFullscreen: false,
  },
  mutations: {
    setIsFullscreen(state, value) {
      state.isFullscreen = value;
    },
  },
  actions: {
    toggleFullscreen(context, value) {
      context.commit('setIsFullscreen', value);
    },
  },
  modules: {},
});
